angular.module('zc.commonApi')

.factory 'ProjectItemPrice', ($resource, $q, BaseProjectCrudService) ->
  class ProjectItemPrice extends BaseProjectCrudService

  new ProjectItemPrice(
    $resource
    $q
    '/api/projects/:projectId/item_prices/:id'
    'item_price'
    'item_prices'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/item_price.service.coffee